var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimeoutBackground = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 400,
    viewBox: "0 0 1440 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_242_5926)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 480,
    fill: "url(#paint0_linear_242_5926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1867.16 658.456C1867.16 658.456 1607.36 744.011 1385.69 703.885C1164.02 663.758 1091.66 505.23 1178.82 267.418C1265.98 29.6053 1039.63 -49.4853 1039.63 -49.4853C1039.63 -49.4853 2023.19 -164.732 1867.16 658.456Z",
    fill: "url(#paint1_linear_242_5926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-190.381 14.2387C-190.381 14.2387 82.706 -1.16081 286.439 94.9711C490.171 191.103 519.035 362.957 373.294 570.108C227.553 777.258 425.714 912.236 425.714 912.236C425.714 912.236 -554.155 768.992 -190.381 14.2387Z",
    fill: "url(#paint2_linear_242_5926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.145 466.219C74.7769 223.589 265.83 -26.1088 390.777 -120.629L96.7557 -593.642C-377.683 -572.961 -1305.34 301.672 -706.014 -81.773C-78.8769 -483.012 151.277 590.504 60.7735 830.574C241.967 810.218 545.512 708.849 310.145 466.219Z",
    fill: "url(#paint3_radial_242_5926)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip1_242_5926)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M728.858 0L215.635 520H753.774L1035.63 0H728.858Z",
    fill: "url(#paint4_linear_242_5926)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M847.207 0L426.59 520H571.322L963.733 0H847.207Z",
    fill: "url(#paint5_linear_242_5926)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M772.461 0L367.866 520H309.072L752.218 0H772.461Z",
    fill: "url(#paint6_linear_242_5926)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M995.145 0L630.201 520H690.664L1019.99 0H995.145Z",
    fill: "url(#paint7_linear_242_5926)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_242_5926",
    x1: 720,
    y1: 480,
    x2: 636.964,
    y2: 14.8222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_242_5926",
    x1: 1409.87,
    y1: 790.739,
    x2: 1230.67,
    y2: 138.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_242_5926",
    x1: 288.376,
    y1: 211.336,
    x2: 387.206,
    y2: 728.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000C2A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_242_5926",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-549.775 -1233.87) rotate(64.1975) scale(1853.61 1190.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AABFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_242_5926",
    x1: 940.104,
    y1: -45.6702,
    x2: 597.567,
    y2: 389.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_242_5926",
    x1: 937.042,
    y1: -10.498,
    x2: 484.362,
    y2: 575.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_242_5926",
    x1: 772.636,
    y1: -13.5,
    x2: 467.156,
    y2: 349.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_242_5926",
    x1: 1008.63,
    y1: -0.0000133349,
    x2: 658.962,
    y2: 542.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_242_5926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 480,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_242_5926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 820,
    height: 520,
    fill: "white",
    transform: "translate(215.635)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimeoutBackground);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";